import styled from "styled-components";

export const UploadSlipFormStyled = styled.div`
  .input_wrap {
    &.mb_30 {
      margin-bottom: 30px;
    }
    .form_label {
      margin: 12px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .btn_submit_wrap {
    margin: auto;
    width: 100%;
    max-width: 167px;
  }
`;
